var map = {
	"./results-widget-1/widget": "app/styles/client/widgets/results-widget-1/widget",
	"./standard-widget-1/widget": "app/styles/client/widgets/standard-widget-1/widget",
	"./standard-widget-2/widget": "app/styles/client/widgets/standard-widget-2/widget"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4670;